import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
// import PostChargeModal from 'src/components/resident/PostChargeModal';
// import { tenantsArray } from 'src/configs/sampleData';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const TopActionButtons = observer(_ref => {
  let allocationCycleId = _ref.allocationCycleId,
    showEnrollModal = _ref.showEnrollModal;
  const store = useStore();
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Residencies Page';
  const _useState = useState(showEnrollModal ? true : false),
    _useState2 = _slicedToArray(_useState, 2),
    showCurrentEnrollModal = _useState2[0],
    setShowCurrentEnrollModal = _useState2[1];
  const handleShowCurrentEnrollModal = par => {
    setShowCurrentEnrollModal(par);
  };
  const propertyId = new URLSearchParams(location.search).get('id');

  // const postChargeTrigger = (
  //   <Button variant="action">
  //     <Icon type="coin" />
  //     Post charge or credit
  //   </Button>
  // );

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10,
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: !store.company.companyFeatureStore.disableEnrollResident ? 4 : 6,
    lg: true
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    to: "/allocation_tables?allocationCycleId=".concat(allocationCycleId, "&propertyId=").concat(propertyId),
    variant: "action",
    'custom-attribute': '826-residents-page-top-actions-btns'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "table"
  }), t('dashboard_page.process_bills'))), !store.company.companyFeatureStore.disableEnrollResident && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: true
  }, /*#__PURE__*/React.createElement(EnrollmentModal, {
    propertyId: propertyId,
    showCurrentEnrollModal: showCurrentEnrollModal,
    handleShowCurrentEnrollModal: handleShowCurrentEnrollModal,
    page: page
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: !store.company.companyFeatureStore.disableEnrollResident ? 4 : 6,
    lg: true
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-controls": "action-menu",
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": "resident menu",
    id: "action-menu-trigger",
    onClick: () => navigate("/edit_property?id=".concat(propertyId)),
    variant: "action",
    'custom-attribute': '827-residents-page-top-actions-btns'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("div", {
    className: "button-text"
  }, t('residencies_page.edit_property_details')))));
});